import { linkPrincipalPrefix } from '@tunasong/models'
import type { ACL } from '@tunasong/schemas'

/**
 * The ACLs a person-oriented access list should show.
 *
 * `link:` principals are authorized-link credentials, not people. They are minted and
 * revoked by the access-link service and managed in the calendar link panel, which is
 * the surface that can explain what revoking one does. Filtering them here — rather
 * than at render — also keeps them out of the profile lookup that consumers derive from
 * this list, since a link principal has no profile and never will.
 */
export const visibleAcls = (acls: ACL[] = []) =>
  acls.filter(
    (acl, idx) =>
      acls.findIndex(other => other.principal === acl.principal) === idx &&
      !acl.principal.startsWith(linkPrincipalPrefix)
  )
